import styled from "styled-components";
import PlaceholderImg from "../img/icons/placeholder-icon.svg?react";

const StyledPlaceholderImg = styled(PlaceholderImg)`
  position: absolute;
  top: 6px;
  transform: translateX(-50%);
  width: 25px;
  height: 25px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    top: 20px;
    width: 40px;
    height: 40px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    top: 16px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    top: 24px;
    width: 50px;
    height: 50px;
  }
`;

const PlaceholderIcon = () => {
  return <StyledPlaceholderImg />;
};

export default PlaceholderIcon;
